module.exports = __webpack_public_path__ + "img/museum.3666a5fc.svg";